import { render, staticRenderFns } from "./CandidateColor.vue?vue&type=template&id=7344ebc2&scoped=true&lang=pug"
import script from "./CandidateColor.vue?vue&type=script&lang=js"
export * from "./CandidateColor.vue?vue&type=script&lang=js"
import style0 from "./CandidateColor.vue?vue&type=style&index=0&id=7344ebc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7344ebc2",
  null
  
)

export default component.exports